// assets/wishlist-text.js

document.addEventListener("DOMContentLoaded", function () {
  const observer = new MutationObserver(() => {
    const btns = document.querySelectorAll('.swym-button');
    btns.forEach(btn => {
      if (btn.textContent.includes('ほしい物リスト')) {
        btn.textContent = 'お気に入り';
      }
      if (btn.textContent.includes('ほしい物リストに追加済み')) {
        btn.textContent = '登録済み';
      }
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
});

window.SwymCallbacks = window.SwymCallbacks || [];
window.SwymCallbacks.push(function(swym) {
  console.log('✅ Swym is fully loaded');

  const btns = document.querySelectorAll('.swym-button');
  btns.forEach(btn => {
    if (btn.textContent.includes('ほしい物リスト')) {
      btn.textContent = 'お気に入り';
    } else if (btn.textContent.includes('ほしい物リストに追加済み')) {
      btn.textContent = '登録済み';
    }

    btn.classList.add('your-class');
  });
});